<template>
<div class="view-leaps-challenge-overlay">
   <div class="container-fluid">
      <div id="myNav" class="overlay overlay-overall-width-100Perc">
          <div class="overlay-content center-aligned-div white-porition-overlay-width-80Perc background-color-white margin-bottom-2Perc">
              <div class="row">
                <div class="col-md-12 col-lg-12">
                  <div class="text-right close-text-font-style margin-right-2Perc margin-top-2Perc cursor-pointer" @click="updateHideViewLeapsChallengeOverlayFlag($event)">
                    <img src= "../../../assets/images/close.svg" class="img-responsive close-img-width-height margin-top-3Perc float-right" alt="close-icon">
                  </div>  
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right">
                  <b>Title:</b>
                </div>
                <div class="col-md-3 col-lg-3 create-lesson-input-text-style text-align-left padding-left-0Px">
                  {{objToPass.ChallengeTitle}}
                </div>
                <div class="col-md-2 col-lg-2 text-align-right create-lesson-input-text-style">
                    <b>Is Active:</b>
                </div>
                <div class="col-md-3 col-lg-3 text-align-left create-lesson-input-text-style">
                  {{objToPass.IsActive ? 'Yes' : 'No'}}
                </div>
                <div class="col-md-1 col-lg-1"></div>
              </div>

              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right">
                  <b>Attached Categories:</b>
                </div>
                <div class="col-md-3 col-lg-3 create-lesson-input-text-style text-align-left padding-left-0Px">
                  <div v-for="(categoryObj, index) in selectedCategoryValues" :key="index">
                    {{(index + 1) + ') ' + categoryObj.name}}
                  </div>
                  <div class="text-color-red" v-if="selectedCategoryValues.length === 0">
                    Not Found.
                  </div>
                </div>
                <div class="col-md-2 col-lg-2 text-align-right create-lesson-input-text-style">
                    <b>Attached Intentions:</b>
                </div>
                <div class="col-md-3 col-lg-3 text-align-left create-lesson-input-text-style">
                  <div v-for="(intentionObj, index) in selectedIntentionValues" :key="index">
                    {{(index + 1) + ') ' + intentionObj.name}}
                  </div>
                  <div class="text-color-red" v-if="selectedIntentionValues.length === 0">
                    Not Found.
                  </div>
                </div>
                <div class="col-md-1 col-lg-1"></div>
              </div>
              

              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right">
                  <b>Created TS:</b>
                </div>
                <div class="col-md-3 col-lg-3 create-lesson-input-text-style text-align-left padding-left-0Px">
                  {{objToPass.CreatedTS}}
                </div>
                <div class="col-md-2 col-lg-2 text-align-right create-lesson-input-text-style">
                    <b>Updated TS:</b>
                </div>
                <div class="col-md-3 col-lg-3 text-align-left create-lesson-input-text-style">
                  {{objToPass.UpdatedTS}}
                </div>
                <div class="col-md-1 col-lg-1"></div>
              </div>
            
              <div class="row">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right">
                </div>
                <div class="col-md-5 col-lg-5 padding-left-0Px text-align-left create-lesson-input-text-style">
                  <span v-if="notActiveAssocitedRowsFound" class="font-size-12px"><b>* Red Row = Either they got Deleted Or Not Active Action Found.</b></span>
                </div>
                <div class="create-lesson-input-text-style col-md-4 col-lg-4 padding-left-0Px text-align-right">
                </div>
              </div>

              <div class="row margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right">
                  <b>Associated Actions:</b>
                </div>
                <div class="col-md-8 col-lg-8 padding-left-0Px text-align-left create-lesson-input-text-style">
                  <div v-for="(actionObj, index) in objToPass.ChallengeActions" :key="index" :class="{'text-color-red': !isActiveCurrentAction(actionObj)}">
                  {{(index + 1) + ') ' + actionObj.ActionName + getActionVersion(actionObj)}}
                  </div>
                </div>
                <div v-if="objToPass.ChallengeActions.length === 0" class="col-md-8 col-lg-8 padding-left-0Px text-align-left create-lesson-input-text-style">
                  No Associated Actions Found.
                </div>
                <div class="col-md-1 col-lg-1"></div>
              </div>

              <div class="row margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right">
                  <b>Description:</b>
                </div>
                <div class="col-md-8 col-lg-8 padding-left-0Px text-align-left create-lesson-input-text-style">
                  <span v-html="objToPass.ChallengeDescription"></span>
                </div>
                <div class="col-md-1 col-lg-1"></div>  
              </div>

              <div class="row margin-bottom-2Perc">
                <div class="col-md-5 col-lg-5">
                </div>  
                <div class="col-md-2 col-lg-2">
                  <button class="btn btn-primary btn-block create-lesson-overlay-button-BG black-font-color" @click="updateHideViewLeapsChallengeOverlayFlag($event)">Close</button>
                </div>  
                <div class="col-md-5 col-lg-5">
                </div>
              </div>
              <div class="row">
              </div>         
          </div>
      </div>
 </div>
 </div>
</template>

<script>
import { constants } from '@/utils/constants'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
import { find, forEach } from 'lodash'
import { leapsCategoryService } from '@/server-util/leaps-category-service'
import { leapsActionService } from '@/server-util/leaps-action-service'
import { leapsIntentionService } from '@/server-util/leaps-intention-service'
export default {
  props: ['currSelectedObj'],
  created: function () {
    this.getLeapsCategoryList()
  },
  data: function () {
    return {
      constants: constants,
      notActiveAssocitedRowsFound: false,
      selectedCategoryValues: [],
      selectedIntentionValues: [],
      objToPass: {
        ChallengeLibraryId: '',
        ChallengeTitle: '',
        ChallengeDescription: '',
        IsActive: false,
        CreatedTS: '',
        UpdatedTS: '',
        ChallengeActions: [],
        ChallengeCategories: '',
        ChallengeIntentions: ''
      }
    }
  },
  name: 'view-leaps-challenge-overlay',
  methods: {
    isActiveCurrentAction: function (actionObj) {
      const foundObj = find(this.getGlobalActionList, (obj) => {
        return obj.ActionLibraryId === actionObj.ActionLibraryId
      })
      if (foundObj !== undefined && foundObj !== 'undefined' && foundObj !== null && foundObj !== 'null' && foundObj !== '') {
        if (!foundObj.IsActive || this.notActiveAssocitedRowsFound) {
          this.notActiveAssocitedRowsFound = true
        }
        return foundObj.IsActive
      }
      return false
    },
    getActionVersion: function (currActionObj) {
      const foundObj = find(this.$store.state.leapsActionList, (obj) => {
        return obj.ActionLibraryId === currActionObj.ActionLibraryId
      })
      if ((foundObj !== undefined && foundObj !== 'undefined' && foundObj !== null && foundObj !== 'null' && foundObj !== '') && (foundObj.ActionVersion !== undefined && foundObj.ActionVersion !== 'undefined' && foundObj.ActionVersion !== null && foundObj.ActionVersion !== 'null' && foundObj.ActionVersion !== '' && foundObj.ActionVersion.trim().length !== 0)) {
        return ' [' + foundObj.ActionVersion + ']'
      }
      return ''
    },
    setDefaultValues: function () {
      if (this.currSelectedObj.ChallengeActions !== undefined && this.currSelectedObj.ChallengeActions !== 'undefined' && this.currSelectedObj.ChallengeActions !== null && this.currSelectedObj.ChallengeActions !== 'null' && this.currSelectedObj.ChallengeActions !== '') {
        this.objToPass.ChallengeActions = JSON.parse(this.currSelectedObj.ChallengeActions)
      }
      this.objToPass.ChallengeLibraryId = this.currSelectedObj.ChallengeLibraryId
      this.objToPass.ChallengeTitle = this.currSelectedObj.ChallengeTitle
      this.objToPass.IsActive = this.currSelectedObj.IsActive
      this.objToPass.CreatedTS = this.currSelectedObj.CreatedTS
      if (this.objToPass.CreatedTS.indexOf('Z') === -1) {
        this.objToPass.CreatedTS += 'Z'
      }
      this.objToPass.CreatedTS = dmAdminUtils.covertUtcToEst(this.objToPass.CreatedTS)
      this.objToPass.UpdatedTS = this.currSelectedObj.UpdatedTS
      if (this.objToPass.UpdatedTS.indexOf('Z') === -1) {
        this.objToPass.UpdatedTS += 'Z'
      }
      this.objToPass.UpdatedTS = dmAdminUtils.covertUtcToEst(this.objToPass.UpdatedTS)
      this.objToPass.ChallengeDescription = (this.currSelectedObj.ChallengeDescription !== undefined && this.currSelectedObj.ChallengeDescription !== 'undefined' && this.currSelectedObj.ChallengeDescription !== null && this.currSelectedObj.ChallengeDescription !== 'null' && this.currSelectedObj.ChallengeDescription !== '' && this.currSelectedObj.ChallengeDescription.trim().length !== 0) ? this.currSelectedObj.ChallengeDescription : '<span style="color:red">Not Found.</span>'
      this.selectedCategoryValues = (this.currSelectedObj.ChallengeCategories !== undefined && this.currSelectedObj.ChallengeCategories !== 'undefined' && this.currSelectedObj.ChallengeCategories !== null && this.currSelectedObj.ChallengeCategories !== 'null' && this.currSelectedObj.ChallengeCategories !== '') ? this.bindChallengeCategories(JSON.parse(this.currSelectedObj.ChallengeCategories)) : []
      this.selectedIntentionValues = (this.currSelectedObj.ChallengeIntentions !== undefined && this.currSelectedObj.ChallengeIntentions !== 'undefined' && this.currSelectedObj.ChallengeIntentions !== null && this.currSelectedObj.ChallengeIntentions !== 'null' && this.currSelectedObj.ChallengeIntentions !== '') ? this.bindChallengeIntentions(JSON.parse(this.currSelectedObj.ChallengeIntentions)) : []
    },
    bindChallengeCategories: function (challengeCategories) {
      var arrToReturn = []
      forEach(challengeCategories, (categoryId) => {
        const foundObj = find(this.getGlobalCategoryList, (obj) => {
          return categoryId === obj.CategoryId
        })
        if (foundObj !== undefined && foundObj !== 'undefined' && foundObj !== null && foundObj !== 'null' && foundObj !== '') {
          var objToPush = {
            name: foundObj.CategoryTitle,
            categoryid: foundObj.CategoryId
          }
          arrToReturn.push(objToPush)
        }
      })
      return arrToReturn
    },
    bindChallengeIntentions: function (challengeIntentions) {
      var arrToReturn = []
      forEach(challengeIntentions, (intentionId) => {
        const foundObj = find(this.getGlobalIntentionList, (obj) => {
          return intentionId === obj.IntentionLibraryId
        })
        if (foundObj !== undefined && foundObj !== 'undefined' && foundObj !== null && foundObj !== 'null' && foundObj !== '') {
          var objToPush = {
            name: foundObj.IntentionTitle,
            intentionid: foundObj.IntentionLibraryId
          }
          arrToReturn.push(objToPush)
        }
      })
      return arrToReturn
    },
    getLeapsCategoryList: function () {
      var storeObj = this.$store
      if (
        storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== ''
      ) {
        this.$store.state.isLoading = true
        leapsCategoryService
          .getLeapsCategoryList(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.leapsCategoryList = responseObj.data
              this.getLeapsIntentionList()
            } else {
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token is NULL hence declined LOADING LEAPS CATEGORY LIST'
        )
      }
    },
    getLeapsIntentionList: function () {
      var storeObj = this.$store
      if (
        storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== ''
      ) {
        leapsIntentionService
          .getLeapsIntentionList(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.leapsIntentionList = responseObj.data
              this.getLeapsActionList()
            } else {
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token is NULL hence declined LOADING LEAPS INTENTION LIST'
        )
      }
    },
    getLeapsActionList: function () {
      var storeObj = this.$store
      if (
        storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== ''
      ) {
        leapsActionService
          .getLeapsActionList(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              storeObj.state.leapsActionList = responseObj.data
              this.setDefaultValues()
              this.$store.state.isLoading = false
            } else {
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token is NULL hence declined LOADING LEAPS ACTION LIST'
        )
      }
    },
    updateHideViewLeapsChallengeOverlayFlag: function (event) {
      var objToReturn = {
        closeOverlay: true,
        createdObj: null
      }
      this.$emit('emittedValue', objToReturn)
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    }
  },
  components: {},
  computed: {
    getGlobalActionList: {
      get: function () {
        return this.$store.state.leapsActionList
      },
      set: function (newValue) {
        this.$store.state.leapsActionList = newValue
      }
    },
    getGlobalCategoryList: {
      get: function () {
        return this.$store.state.leapsCategoryList
      },
      set: function (newValue) {
        this.$store.state.leapsCategoryList = newValue
      }
    },
    getGlobalIntentionList: {
      get: function () {
        return this.$store.state.leapsIntentionList
      },
      set: function (newValue) {
        this.$store.state.leapsIntentionList = newValue
      }
    }
  }
}
</script>

<style scoped>
.font-size-12px {
  font-size: 12px;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.red{
  background-color: red;
}
.MainDiv
{
  overflow-y: hidden !important;
}
.margin-Top-0Perc{
  margin-top: 0%;
}
.margin-Top-1Perc{
  margin-top: 1%;
}
.margin-Top-2Perc
{
	margin-top: 2%;
}
.margin-Top-3Perc
{
	margin-top: 3%;
}
.margin-Top-8Perc
{
	margin-top: 8%;
}
.margin-bottom-0Perc
{
	margin-bottom: 0%;
}
.margin-bottom-2Perc
{
	margin-bottom: 2%;
}
.margin-left-0Perc
{
    margin-left:0%;
}
.margin-left-1Perc
{
    margin-left:2%;
}
.margin-left-2Perc
{
    margin-left:2%;
}
.margin-left-3Perc{
  margin-left:3%;
}
.margin-left-4Perc
{
    margin-left:4%;
}
.margin-left-5Perc{
  margin-left:5%;
}
.margin-left-6Perc{
  margin-left:6%
}
.margin-left-9Perc
{
    margin-left:9%;
}
.padding-Left-0px
{
  padding-left: 0px !important;
}
.padding-Left-30px
{
  padding-left: 3% !important;
}
.text-align-center
{
  text-align: center;
}
.left-border
{
  border-left: 1px solid #aaa;
}

.background-color-red
{
	background-color: red;
}
.cf-border
{
	border:1px solid black;
}
.text-align-left
{
  text-align: left;
}
.font-size-1-3vw
{
  font-size: 1.3vw;
}
.font-size-20px
{
  font-size: 20px;
}
.background-gray{
  background-color: #ddd;

}

.border-rounded{
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}

  .overflow-x-hidden{
    overflow-x: hidden !important;
  }
  .font-size-18px {
  font-size: 18px;
}
.gray-border {
  border: 1px solid #aaa;
}
.white-BG {
  background-color: #ffffff;
}
.width-70Perc {
  width: 70%;
}
.width-90Perc {
  width: 90%;
}
.margin-auto{
margin: auto;
}
.margin-bottom-0px {
  margin-bottom: 0px !important;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-content {
  position: relative;
  top: 7%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.center-aligned-div {
  margin: 0 auto;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.background-color-white {
  background-color: #ffffff !important;
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.margin-top-2Perc {
  margin-top: 2%;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.float-right {
  float: right;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.text-color-red {
  color: red;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 17px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
.padding-left-0Px {
  padding-left: 0px !important;
}
switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.text-align-right {
  text-align: right;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color
{
  color: #000 !important;
}
</style>





// WEBPACK FOOTER //
// src/components/leaps/challenges/ViewLeapsChallengeOverlay.vue